import { useEffect, useState } from "react";
import CommonModal from "../modalLayout/CommonModal";

const AddOriginalPoNumberModal = ({
  show,
  setShow,
  onSave,
  initialValue = "",
  confirmLoading = false,
}) => {
  const [draft, setDraft] = useState("");
  const hasExisting = Boolean(String(initialValue || "").trim());

  useEffect(() => {
    if (!show) return;
    setDraft(String(initialValue || "").trim());
  }, [show, initialValue]);

  const handleConfirm = async () => {
    const value = draft.trim();
    if (!value) return;
    await onSave?.(value);
  };

  const handleDiscard = () => {
    setDraft("");
    setShow?.(false);
  };

  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      title={hasExisting ? "Edit VA PO Number" : "Add VA PO Number"}
      centered
      onConfirm={handleConfirm}
      onCancel={handleDiscard}
      onHide={handleDiscard}
      confirmLabel="Confirm"
      confirmLoading={confirmLoading}
      confirmDisabled={!draft.trim()}
    >
      <input
        type="text"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        className="form-control"
        placeholder="Enter VA PO Number"
        disabled={confirmLoading}
        autoFocus
      />
    </CommonModal>
  );
};

export default AddOriginalPoNumberModal;
